<script type="text/javascript">
	import { createEventDispatcher } from "svelte"
	import { get, writable } from "svelte/store"

	import '../LayerList/LayerList.scss';
	import LayerListSwitch from '../LayerList/LayerListSwitch.svelte';

	const dispatch = createEventDispatcher(); // change
	export let label;
	export let disabled;
	export let checked = writable(true);

	$: {
		$checked;
		dispatch("change", $checked);
	}
</script>

<LayerListSwitch
		label={label}
		disabled={disabled}
		bind:checked={$checked}
		/>
